// @core/api/endpoints/landing/list_landing_pages.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLandingPagesResponse,
} from '../../../types/landing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/landing';

/**
 * List landing pages
 * Returns all landing pages for the current tenant. Supports filtering by status and search.
 */
export async function ListLandingPages(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListLandingPagesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/landing/pages`;
  const requestOptions = options;
  return client.get<ListLandingPagesResponse>(requestPath, { ...requestOptions, params });
}
